module.exports = __webpack_public_path__ + "img/kelebihan-4.47ca542b.jpg";